import { render, staticRenderFns } from "./DateImageSlideshow.vue?vue&type=template&id=642eb458"
import script from "./DateImageSlideshow.vue?vue&type=script&lang=js"
export * from "./DateImageSlideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports